import { render, staticRenderFns } from "./zhuangxiupinzhengWH.vue?vue&type=template&id=2a1a929e&scoped=true&"
import script from "./zhuangxiupinzhengWH.vue?vue&type=script&lang=js&"
export * from "./zhuangxiupinzhengWH.vue?vue&type=script&lang=js&"
import style0 from "./zhuangxiupinzhengWH.vue?vue&type=style&index=0&id=2a1a929e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a929e",
  null
  
)

export default component.exports